import React from 'react';
import NotificationMenuItemContainer from 'components/Notifications/NotificationMenuItemContainer'
import styles from './SidebarSubMenu.module.scss';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CustomMenuItem from './CustomMenuItem';
import Can from 'Can';
import { userPermissions } from "config/userRoles";
import { useAuthCenter } from 'AuthCenter'
import { NavLink, useNavigate } from 'react-router-dom';
import routesConfig from 'config/routesConfig'
import PersonIcon from 'icons/PersonIcon';

const SidebarSubMenuContainer = (props) => {
  const authCenter = useAuthCenter();
  const navigate = useNavigate();

  const handleLogOut = () => {
    authCenter.logOut().then(() => {
      navigate('/login');
    });
  }

  return (
    <div className={styles.root}>
      <CustomMenuItem>
        <NavLink to={`/${routesConfig.resources.userProfile.baseUrl}`}><PersonIcon/> <span className="menu-label">User Profile</span></NavLink>
      </CustomMenuItem>
      <Can allowedRoles={userPermissions.notifications.root}>
        <NotificationMenuItemContainer handleSidebarClose={props.handleSidebarClose}/>
      </Can>
      <CustomMenuItem onClick={handleLogOut}>
        <span>
          <ExitToAppIcon/> <span className="menu-label">Log-out</span>
        </span>
      </CustomMenuItem>
    </div>
  );
}

export default SidebarSubMenuContainer;